import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown, Modal} from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaFileExport, FaFileImport, FaEraser, FaTrashAlt } from "react-icons/fa";
import api from "../../services/api";
import AsyncSelect from 'react-select/async';
import { hasPerm, formataCNPJ, formataCPF, getCurrentUser, tiposAcesso, prestadoresCategorias } from '../../common/utils';
import Paginacao from '../../common/pagination';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

class Medicos extends Component {
    constructor(props) {
        super(props);
        this.handleChangeFiltros = this.handleChangeFiltros.bind(this);
        this.handleChangeBusca = this.handleChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaPrestador = this.buscaPrestador.bind(this);      

        this.state = {
            listRegistros: [],
            error: "",
            prestador_id: "",
            page_numb: 1,
            loading: true,
            busca_nome: '',
            busca_crm: '',
            busca_crm_uf: '',
            categoria:'',
            filtro_cliente_id: '',
            filtro_cliente_nome: '',
            filtro_programa_id: '',
            filtro_programa_nome: '',
            filtro_especialidade_id: '',
            filtro_especialidade_nome: '',
            programa_select_key: 0,
            categoria_select_key: 0,
            showModal: false,
            permite_editar: true,
            envioCadastroMedicoPendente: false,
            file: false
        };
        
        // Bind de métodos
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this)

        this.ufOptions = {
            "AC": "Acre",
            "AL": "Alagoas",
            "AP": "Amapá",
            "AM": "Amazonas",
            "BA": "Bahia",
            "CE": "Ceará",
            "DF": "Distrito Federal",
            "ES": "Espírito Santo",
            "GO": "Goiás",
            "MA": "Maranhão",
            "MT": "Mato Grosso",
            "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais",
            "PA": "Pará",
            "PB": "Paraíba",
            "PR": "Paraná",
            "PE": "Pernambuco",
            "PI": "Piauí",
            "RJ": "Rio de Janeiro",
            "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul",
            "RO": "Rondônia",
            "RR": "Roraima",
            "SC": "Santa Catarina",
            "SP": "São Paulo",
            "SE": "Sergipe",
            "TO": "Tocantins"
        };
    }

    componentDidMount(){
        this.consultaRegistro(this.state.busca_nome, this.state.page_numb)
    }

    // Método para abrir o Modal
    handleShowModal() {
        this.setState({ showModal: true });
    }

    verificaBloqueioEdicao = () => {
        const tipos_acesso = tiposAcesso();

        if ('gestor' in tipos_acesso) {
            if ('tipo_gestor' in tipos_acesso.gestor && tipos_acesso.gestor.tipo_gestor == 'industria') {
                this.setState({ permite_editar: false });            
            }            
        }
    }

    /*handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                filtro_programa_id: "", 
                filtro_programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1 
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
                prestador_select_key: prevState.categoria_select_key + 1 
            }));
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };*/

    // Método para fechar o Modal
    handleCloseModal() {
        this.setState({ showModal: false });
    }

    handleFileChange(event) {
        const file = event.target.files[0];
        this.setState({ file }, () => {
        });
    }

    consultaRegistro(busca_nome = '', page_numb = 1) {
        let dados_usuario = getCurrentUser();
        
        let url = `/pessoas/prestadores/?nome=${busca_nome}&page=${page_numb}&categoria=medicos`;
    
        if (dados_usuario['ambiente_programa_id']) {
            url += `&programa_id=${dados_usuario['ambiente_programa_id']}`;
        }

        if(this.state.filtro_cliente_id){
            url += '&cliente_id='+this.state.filtro_cliente_id
        }

        if(this.state.filtro_programa_id){
            url += '&programa_id='+this.state.filtro_programa_id
        }

        if (this.state.envioCadastroMedicoPendente) {
            url += `&envio_cadastro_medico_pendente=1`;
        }

        if(this.state.busca_crm){
            url += '&registro='+this.state.busca_crm
        }

        if(this.state.busca_crm_uf){
            url += '&registro_uf='+this.state.busca_crm_uf
        }

        if(this.state.filtro_especialidade_id){
            url += '&especialidade='+this.state.filtro_especialidade_id
        }
    
        this.setState({ loading: true }); // Exiba o carregamento enquanto a solicitação está em andamento
    
        api.get(url)
            .then(response => {
                this.setState({
                    loading: false,
                    error: "",
                    listRegistros: response.data,
                    busca_nome,
                    page_numb 
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar os prestadores, tente novamente.';
    
                if(error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento';
                }
                else if(error.response.status === 403){
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }
    
                this.setState({
                    loading: false,
                    error: erro_msg
                });
            });

            this.verificaBloqueioEdicao()
        
    }
    

    renderRows = () => {
        const isSuperuser = getCurrentUser()?.is_superuser;

        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.nome}</td>
                <td>{item.registro}</td>
                <td>{item.registro_uf}</td>
                <td>
                    {
                        item.dados_especialidades_medicas && item.dados_especialidades_medicas.length > 0
                            ? item.dados_especialidades_medicas.map((especialidade) => especialidade.nome).join(', ')
                            : '-'
                    }
                </td>
                <td>{item.dados_programa?.nome || '-'}</td>
                <td>{item.qtd_pacientes}</td>
                <td>{item.qtd_exames || '-'}</td>
                <td>
                    {item.data_aceite_termo ? (
                        <span className="badge bg-success">Sim</span>
                    ) : (
                        <span className="badge bg-secondary">Não</span>
                    )}
                </td>
                <td>
                    {
                    this.state.permite_editar &&
                    <Button variant="light" href={"/medicos/edit/"+item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button>
                    }
                    {
                    isSuperuser &&
                    <Button variant="light" className="ms-2 text-danger" size="sm" onClick={() => this.confirmarExclusaoMedico(item)}>
                        <FaTrashAlt /> Excluir
                    </Button>
                    }
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={10}>Nenhum médico cadastrado</td>
            </tr>
        );
    };

    handleChangeBusca = (event, fieldName) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleCheckboxChange = (event) => {
        this.setState({ envioCadastroMedicoPendente: event.target.checked });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistro(this.state.busca_nome, num_page)
    };

    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            //this.setState({ opcoesClientes: opcoes });
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregaProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    handleImportar = () => {
        const { filtro_cliente_id, filtro_programa_id, categoria, file } = this.state;
    
        if (!filtro_cliente_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'O campo cliente deve ser preenchido.',
            });
            return;
        }
        if (!filtro_programa_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'O campo programa deve ser preenchido.',
            });
            return;
        }
        if (!categoria) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'O campo categoria deve ser preenchido.',
            });
            return;
        }
        if (!file) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'O campo de arquivo CSV deve ser preenchido.',
            });
            return;
        }
        if (!file.name.endsWith('.csv')) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'O arquivo deve ser do tipo CSV.',
            });
            return;
        }

        const formData = new FormData();
        formData.append('cliente_id', filtro_cliente_id);
        formData.append('programa_id', filtro_programa_id);
        formData.append('categoria', categoria);
        formData.append('file', file);
    
        api.post('/pessoas/importar_medicos/', formData)
            .then(response => {
                Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: 'Importação realizada com sucesso.',
                });
    
                
                this.handleCloseModal()
                this.props.router.navigate("/prestadores?envio_cadastro_medico_pendente=1");
                this.setState({ envioCadastroMedicoPendente: true }, () => {
            });
                
            })
            .catch(error => {
                let errorMessage = 'Houve um erro ao importar os médicos. Tente novamente.';
            
                // Verifica se existe uma mensagem de erro específica no response
                if (error.response && error.response.data && error.response.data.error) {
                    errorMessage = error.response.data.error;
                }
            
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: errorMessage, // Mostra a mensagem de erro da API, se disponível
                });
            });
    }

    buscaPrestador(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaRegistro(this.state.busca_nome)
    };

    buscaCategoria(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });
        
        this.consultaRegistro()
    };

    confirmarEnvioCadastro = () => {
        Swal.fire({
            title: 'Atenção!',
            text: "Deseja realmente enviar o email de confirmação de cadastro?",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, enviar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.enviarConfirmacaoCadastro();
            }
        });
    }

    enviarConfirmacaoCadastro = () => {
        const { filtro_cliente_id, filtro_programa_id, categoria } = this.state;
    
        const payload = {
            cliente_id: filtro_cliente_id,
            programa_id: filtro_programa_id,
            categoria: categoria,
        };
        
        api.post('/pessoas/email-cadastro/', payload)
            .then(response => {
                Swal.fire(
                    'Enviado!',
                    'O email de confirmação de cadastro foi enviado com sucesso.',
                    'success'
                );
                    this.props.router.navigate("/medicos")
            })
            .catch(error => {
                Swal.fire(
                    'Erro!',
                    'Ocorreu um erro ao enviar o email de confirmação.',
                    'error'
                );
            });
    }

    // Super admin: verifica os vínculos do médico antes de confirmar a exclusão
    confirmarExclusaoMedico = (item) => {
        api.get(`/pessoas/prestadores/${item.id}/exclusao/`)
            .then((response) => {
                const dados = response.data;

                if (dados.bloqueado) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Não é possível excluir',
                        html: `O médico <strong>${item.nome}</strong> possui registros de Inside Sales vinculados `
                            + `(${dados.visitas} visita(s) e ${dados.ocorrencias} ocorrência(s)) que impedem a exclusão.<br/><br/>`
                            + `Remova esses registros antes de prosseguir.`,
                    });
                    return;
                }

                Swal.fire({
                    icon: 'warning',
                    title: 'Excluir médico?',
                    html: `O médico <strong>${item.nome}</strong> possui <strong>${dados.exames}</strong> exame(s) e `
                        + `<strong>${dados.atendimentos}</strong> atendimento(s) vinculados.<br/><br/>`
                        + `Ao excluir, ele será <strong>desvinculado</strong> desses registros e o cadastro será removido permanentemente.<br/><br/>`
                        + `Deseja prosseguir?`,
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#6c757d',
                    confirmButtonText: 'Sim, excluir!',
                    cancelButtonText: 'Cancelar',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.excluirMedico(item);
                    }
                });
            })
            .catch(() => {
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: 'Não foi possível verificar os vínculos do médico. Tente novamente.',
                });
            });
    }

    // Super admin: executa a exclusão do médico (desvincula dos registros)
    excluirMedico = (item) => {
        api.delete(`/pessoas/prestadores/${item.id}/exclusao/`)
            .then(() => {
                Swal.fire({
                    icon: 'success',
                    title: 'Excluído!',
                    text: 'O médico foi excluído com sucesso.',
                });
                this.consultaRegistro(this.state.busca_nome, this.state.page_numb);
            })
            .catch((error) => {
                let mensagem = 'Houve um erro ao excluir o médico. Tente novamente.';
                if (error.response && error.response.data && error.response.data.detail) {
                    mensagem = error.response.data.detail;
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: mensagem,
                });
            });
    }

    carregarEspecialidades = async (inputValue) => {
        try {
            const response = await api.get(`/profissionais/especialidades-medicas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(especialidade => ({
                value: especialidade.id,
                label: especialidade.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'especialidade') {
            this.setState(prevState => ({
                filtro_especialidade_id: event.value, 
                filtro_especialidade_nome: event.label
            }));
        } else if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                filtro_programa_id: "", 
                filtro_programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1 
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
                prestador_select_key: prevState.categoria_select_key + 1 
            }));
        }
    }

    limpaFiltro = () => {
        this.setState({
            busca_nome: '',
            busca_crm: '',
            busca_crm_uf: '',
            filtro_especialidade_id: null,
            filtro_programa_id: null,
            filtro_programa_nome: '',
            loading: true
        }, () => {
            this.consultaRegistro('',1);
        })
    }

    render() {
        if (!hasPerm('view_prestadores')) {
            return <Navigate to='/sem-permissao' />
        }

        const customStyles = {
            option: (provided, state) => ({
              ...provided,
              fontSize: '13px',
            }),
            singleValue: (provided, state) => ({
              ...provided,
              fontSize: '13px',
            }),
          };

        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Médicos</h4>
                    </Col>
                    {hasPerm('add_prestadores') && (
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/medicos/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Médico
                        </Button>
                    </Col>
                    )}
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaPrestador}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="busca_nome"
                                                                value={this.state.busca_nome}
                                                                onChange={this.handleChangeBusca}
                                                                placeholder="Nome do médico"
                                                                aria-label="Nome do médico"
                                                                aria-describedby="basic-addon2"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>CRM</Form.Label>                                  
                                                            <Form.Control
                                                                type="text"
                                                                name="busca_crm"
                                                                value={this.state.busca_crm}
                                                                onChange={this.handleChangeBusca}
                                                                placeholder="CRM do médico"
                                                                aria-label="CRM do médico"
                                                                aria-describedby="basic-addon2"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>CRM-UF</Form.Label>   
                                                            <Form.Control as="select" name="busca_crm_uf" value={this.state.busca_crm_uf} onChange={this.handleChangeBusca}>
                                                                <option value="">Selecione o Estado</option>
                                                                {Object.entries(this.ufOptions).map(([sigla, nome]) => (
                                                                    <option key={sigla} value={sigla}>{sigla}</option>
                                                                ))}
                                                            </Form.Control>     
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}> 
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Especialidade</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarEspecialidades}
                                                                defaultOptions
                                                                name="especialidade"
                                                                placeholder="Selecionar especialidade..."
                                                                noOptionsMessage={() => "Nenhuma especialidade encontrada"}
                                                                onChange={e => this.handleChangeFiltros(e, 'especialidade')}
                                                                value={this.state.filtro_especialidade_id ? { value: this.state.filtro_especialidade_id, label: this.state.filtro_especialidade_nome } : null}
                                                                styles={customStyles}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    {dados_usuario['ambiente_programa_id'] === "" && (
                                                    <Col> 
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Programa</Form.Label>
                                                            <AsyncSelect                                           
                                                                cacheOptions
                                                                loadOptions={this.carregaProgramas}
                                                                defaultOptions
                                                                name="programa_id"
                                                                placeholder={'Buscar programa...'}
                                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                                                value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                                                styles={customStyles}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    )}
                                                </Row>

                                                {/*dados_usuario['tipo_usuario'] == '' && hasPerm('import_prestadores') && (
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Envio de e-mail de cadastro pendente</Form.Label>                                  
                                                            <Form.Check
                                                                type="checkbox"
                                                                checked={this.state.envioCadastroMedicoPendente}
                                                                onChange={this.handleCheckboxChange}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>                                                      
                                                )*/}
                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>
                                                
                                                <Button type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                    <FaEraser /> Limpar Filtro
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>

                                {/*(dados_usuario['tipo_usuario'] == '' || dados_usuario['tipo_usuario'] == 'gestor') && (
                                    <Button variant="light" className="ms-2" size="sm" onClick={this.handleShowModal}>
                                        <FaFileImport /> Importar Médicos
                                    </Button>
                                )}
                                {this.state.envioCadastroMedicoPendente && this.state.listRegistros.results.length > 0 && (
                                    <Button variant="primary" className="ms-2" size="sm" onClick={this.confirmarEnvioCadastro}>
                                        <FaFileImport /> Enviar confirmação de cadastro
                                    </Button>
                                )*/}
                            </Col>
                        </Row> 

                        {/* Modal para importação de arquivo */}
                        <Modal show={this.state.showModal} onHide={this.handleCloseModal}>
                            <Modal.Header closeButton>
                                <Modal.Title>Importar Prestadores de Serviço</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                {dados_usuario['ambiente_cliente_id'] === "" && (
                                <Col> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cliente</Form.Label>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregarClientes}
                                            defaultOptions
                                            name="cliente_id"
                                            placeholder="Buscar cliente..."
                                            noOptionsMessage={() => "Nenhum cliente encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'cliente_id')}
                                            value={this.state.filtro_cliente_id ? { value: this.state.filtro_cliente_id, label: this.state.filtro_cliente_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.filtro_cliente_id && dados_usuario['ambiente_programa_id'] === "" && (
                                <Col> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Programa</Form.Label>
                                        <AsyncSelect          
                                            key={this.state.programa_select_key}                                  
                                            cacheOptions
                                            loadOptions={this.carregaProgramas}
                                            defaultOptions
                                            name="programa_id"
                                            placeholder={'Buscar programa...'}
                                            noOptionsMessage={() => "Nenhum programa encontrado"}
                                            onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                            value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                        />
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.filtro_programa_id && dados_usuario['ambiente_programa_id'] === "" && (
                                <Col sm={12} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Categoria</Form.Label>                                  
                                        <Form.Control 
                                            key={this.state.categoria_select_key}                
                                            as="select" name="categoria" value={this.state.categoria} onChange={this.handleChangeFiltros}>
                                        <option value="">Categoria do Prestador</option>
                                            {Object.entries(prestadoresCategorias).map(([chave, valor]) => (
                                                <option key={chave} value={chave}>{valor}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                )}
                                {this.state.categoria && (
                                 <Form.Group>
                                    <Form.Label>Selecione um arquivo CSV para importar:</Form.Label>
                                    <Form.Control 
                                        type="file" 
                                        required={true}
                                        accept=".csv"
                                        onChange={this.handleFileChange}
                                    />
                                </Form.Group>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="" onClick={this.handleCloseModal}>
                                    Fechar
                                </Button>
                                <Button variant="secondary" onClick={this.handleImportar}>
                                    Importar
                                </Button>
                            </Modal.Footer>
                        </Modal>   

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>CRM</th>
                                    <th>CRM-UF</th>
                                    <th>Especialidades</th>
                                    <th>Programa</th>
                                    <th>Qtde. de Pacientes</th>
                                    <th>Qtde. de Exames</th>
                                    <th>Optin Aceito</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={10}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={10}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Medicos);
